import { IPlayUIStateProps } from "../..";
import {
  ITickerDisplayMapDispatchProps,
  ITickerDisplayMapStateProps
} from "./TickerDisplay";
import { DisplayMode } from "../../../../api/api";

export const sharedMapPropsToState = (
  state: IPlayUIStateProps
): ITickerDisplayMapStateProps => ({
  message: state.ticker.message,
  hidden: state.ticker.hidden || state.keypad.hidden,
  isMinimalUI: state.displayMode === DisplayMode.MINIMAL,
  animationStopped: state.ticker.animationStopped,
  view: state.view
});

export const sharedMapDispatchToProps = (
  dispatch
): ITickerDisplayMapDispatchProps => ({});
